import React from 'react'
import PropTypes from 'prop-types'
import { Card, BodyText, PAYPAL_THEME } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'

const IconCard = ({
  cardSize = 'sm',
  Icon,
  as = 'a',
  cardHref,
  headerText,
  bodyText,
  dataTestId,
}) => {
  const { sysColorBackgroundMediumContrast } = PAYPAL_THEME

  return (
    <div
      onClick={() => {
        window.open(cardHref, '_blank')
      }}
    >
      <Card
        size={cardSize}
        data-testid={`iconCard-${dataTestId}`}
        style={{ height: '100%' }}
        className="icon-card-content"
      >
        <Icon as={as} target="_blank" size="lg" color="sysColorLinkMain" />
        <Card.Content style={{ marginTop: '0' }}>
          <BodyText className="icon-card-title">
            <Message id={headerText} />
          </BodyText>
          <BodyText style={{ color: sysColorBackgroundMediumContrast }}>
            <Message id={bodyText} />
          </BodyText>
        </Card.Content>
      </Card>
    </div>
  )
}

IconCard.propTypes = {
  cardSize: PropTypes.oneOf(['xs', 'xs-long', 'sm', 'md', 'lg']),
  Icon: PropTypes.elementType.isRequired,
  as: PropTypes.elementType,
  cardHref: PropTypes.string.isRequired,
  dataTestId: PropTypes.string.isRequired,
  headerText: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
}

export default IconCard
